// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Header */
.usef-modal-header {
	padding: 1rem 1.5rem;
	border-bottom: 2px solid var(--bs-border-color);
	background-color: var(--bs-body-bg);
}

.usef-modal-title-block {
	display: flex;
	flex-direction: column;
	gap: 0.1rem;
}

.usef-modal-eyebrow {
	font-size: 0.6875rem;
	font-weight: 700;
	letter-spacing: 0.12em;
	text-transform: uppercase;
	color: var(--bs-secondary);
	line-height: 1;
}

.usef-modal-title {
	font-size: 1.15rem;
	font-weight: 700;
	letter-spacing: 0.01em;
	margin: 0;
	line-height: 1.2;
}

/* Modal Body */
.usef-modal-body {
	padding: 1.25rem 1.5rem;
	background-color: var(--bs-body-bg);
}

/* Search Panels */
.usef-search-panels {
	display: flex;
	gap: 0;
	margin-bottom: 1.5rem;
	border: 1px solid var(--bs-border-color);
	border-radius: 0.5rem;
	overflow: hidden;
}

.usef-panel {
	flex: 1;
	min-width: 0;
}

.usef-panel-label {
	font-size: 0.6875rem;
	font-weight: 700;
	letter-spacing: 0.1em;
	text-transform: uppercase;
	color: var(--bs-secondary);
	background-color: var(--bs-tertiary-bg, #f8f9fa);
	border-bottom: 1px solid var(--bs-border-color);
	padding: 0.5rem 1rem;
}

.usef-panel-body {
	padding: 1rem;
}

.usef-panel-divider {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 2.5rem;
	flex-shrink: 0;
	background-color: var(--bs-tertiary-bg, #f8f9fa);
	border-left: 1px solid var(--bs-border-color);
	border-right: 1px solid var(--bs-border-color);
	position: relative;
}

.usef-or-badge {
	font-size: 0.6875rem;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.08em;
	color: var(--bs-secondary);
	background-color: var(--bs-body-bg);
	border: 1px solid var(--bs-border-color);
	border-radius: 50%;
	width: 1.75rem;
	height: 1.75rem;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 1;
}

/* Form Fields */
.usef-field-label {
	font-size: 0.6875rem;
	font-weight: 600;
	letter-spacing: 0.06em;
	text-transform: uppercase;
	color: var(--bs-secondary);
	margin-bottom: 0.3rem;
}

.usef-input {
	font-size: 0.9rem;
}

.usef-search-btn {
	font-size: 0.8125rem;
	font-weight: 600;
	letter-spacing: 0.04em;
}

/* Results Section */
.usef-results-section {
	margin-top: 0.5rem;
}

.usef-results-header {
	display: flex;
	align-items: center;
	gap: 0.75rem;
	margin-bottom: 0.75rem;
	padding-bottom: 0.5rem;
	border-bottom: 1px solid var(--bs-border-color);
}

.usef-results-count {
	font-size: 0.6875rem;
	font-weight: 700;
	letter-spacing: 0.1em;
	text-transform: uppercase;
	color: var(--bs-secondary);
}

/* Result Cards */
.usef-result-card {
	border: 1px solid var(--bs-border-color);
	border-radius: 0.5rem;
	overflow: hidden;
	margin-bottom: 0.75rem;
}

.usef-result-card:last-child {
	margin-bottom: 0;
}

.usef-result-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	padding: 0.75rem 1rem;
	background-color: var(--bs-tertiary-bg, #f8f9fa);
	border-bottom: 1px solid var(--bs-border-color);
}

.usef-result-name {
	font-size: 1rem;
	font-weight: 700;
	line-height: 1.2;
	flex: 1;
	min-width: 0;
}

.usef-result-actions {
	display: flex;
	align-items: center;
	gap: 0.875rem;
	flex-shrink: 0;
}

.usef-select-btn {
	font-size: 0.75rem;
	font-weight: 700;
	letter-spacing: 0.06em;
	text-transform: uppercase;
	padding: 0.3rem 0.875rem;
	white-space: nowrap;
}

.usef-suspension-alert {
	border-radius: 0;
	border-left: none;
	border-right: none;
	border-top: none;
	margin-bottom: 0 !important;
	padding: 0.5rem 1rem;
	font-size: 0.875rem;
}

.usef-result-body {
	padding: 0.875rem 1rem;
}

/* Key-Value Pairs */
.usef-kv {
	display: flex;
	flex-direction: column;
	gap: 0.1rem;
}

.usef-kv--inline {
	flex-direction: row;
	align-items: center;
	gap: 0.4rem;
}

.usef-kv-label {
	font-size: 0.625rem;
	font-weight: 700;
	letter-spacing: 0.1em;
	text-transform: uppercase;
	color: var(--bs-secondary);
	line-height: 1;
}

.usef-kv-value {
	font-size: 0.875rem;
	font-weight: 500;
	line-height: 1.2;
	color: var(--bs-body-color);
}

.usef-id-value {
	font-size: 0.9rem;
	font-weight: 700;
	font-variant-numeric: tabular-nums;
}

/* Details Grid */
.usef-details-grid {
	display: flex;
	flex-wrap: wrap;
	gap: 0.75rem 1.5rem;
	margin-bottom: 0.75rem;
}

/* Sub-sections (Owners, Memberships, Measurements) */
.usef-memberships {
	border-top: 1px solid var(--bs-border-color);
	padding-top: 0.75rem;
	margin-top: 0.25rem;
}

.usef-subsection-label {
	font-size: 0.625rem;
	font-weight: 700;
	letter-spacing: 0.12em;
	text-transform: uppercase;
	color: var(--bs-secondary);
	margin-bottom: 0.5rem;
}

.usef-membership-row {
	display: flex;
	flex-wrap: wrap;
	gap: 0.625rem 1.25rem;
	padding: 0.5rem 0;
	border-bottom: 1px solid var(--bs-border-color-translucent, rgba(0,0,0,.08));
}

.usef-membership-row:last-child {
	border-bottom: none;
	padding-bottom: 0;
}

/* Empty State */
.usef-empty-state {
	text-align: center;
	padding: 2.5rem 1rem;
	color: var(--bs-secondary);
}

.usef-empty-icon {
	font-size: 2rem;
	opacity: 0.4;
	margin-bottom: 0.75rem;
	display: block;
}

.usef-empty-text {
	font-size: 0.875rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/horses/modal-usef-horse-search/modal-usef-horse-search.component.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;CACC,oBAAoB;CACpB,+CAA+C;CAC/C,mCAAmC;AACpC;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,oBAAoB;CACpB,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,0BAA0B;CAC1B,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,sBAAsB;CACtB,SAAS;CACT,gBAAgB;AACjB;;AAEA,eAAe;AACf;CACC,uBAAuB;CACvB,mCAAmC;AACpC;;AAEA,kBAAkB;AAClB;CACC,aAAa;CACb,MAAM;CACN,qBAAqB;CACrB,wCAAwC;CACxC,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,OAAO;CACP,YAAY;AACb;;AAEA;CACC,oBAAoB;CACpB,gBAAgB;CAChB,qBAAqB;CACrB,yBAAyB;CACzB,0BAA0B;CAC1B,gDAAgD;CAChD,+CAA+C;CAC/C,oBAAoB;AACrB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,aAAa;CACb,cAAc;CACd,gDAAgD;CAChD,6CAA6C;CAC7C,8CAA8C;CAC9C,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB,gBAAgB;CAChB,yBAAyB;CACzB,sBAAsB;CACtB,0BAA0B;CAC1B,mCAAmC;CACnC,wCAAwC;CACxC,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,cAAc;AACf;;AAEA,gBAAgB;AAChB;CACC,oBAAoB;CACpB,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,0BAA0B;CAC1B,qBAAqB;AACtB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,oBAAoB;CACpB,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA,oBAAoB;AACpB;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,YAAY;CACZ,sBAAsB;CACtB,sBAAsB;CACtB,+CAA+C;AAChD;;AAEA;CACC,oBAAoB;CACpB,gBAAgB;CAChB,qBAAqB;CACrB,yBAAyB;CACzB,0BAA0B;AAC3B;;AAEA,iBAAiB;AACjB;CACC,wCAAwC;CACxC,qBAAqB;CACrB,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,SAAS;CACT,qBAAqB;CACrB,gDAAgD;CAChD,+CAA+C;AAChD;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,OAAO;CACP,YAAY;AACb;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,aAAa;CACb,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,wBAAwB;CACxB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,2BAA2B;CAC3B,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;AACvB;;AAEA,oBAAoB;AACpB;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,qBAAqB;CACrB,yBAAyB;CACzB,0BAA0B;CAC1B,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,gBAAgB;CAChB,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,kCAAkC;AACnC;;AAEA,iBAAiB;AACjB;CACC,aAAa;CACb,eAAe;CACf,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA,qDAAqD;AACrD;CACC,4CAA4C;CAC5C,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,sBAAsB;CACtB,yBAAyB;CACzB,0BAA0B;CAC1B,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,qBAAqB;CACrB,iBAAiB;CACjB,4EAA4E;AAC7E;;AAEA;CACC,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA,gBAAgB;AAChB;CACC,kBAAkB;CAClB,oBAAoB;CACpB,0BAA0B;AAC3B;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,sBAAsB;CACtB,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB","sourcesContent":["/* Modal Header */\n.usef-modal-header {\n\tpadding: 1rem 1.5rem;\n\tborder-bottom: 2px solid var(--bs-border-color);\n\tbackground-color: var(--bs-body-bg);\n}\n\n.usef-modal-title-block {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.1rem;\n}\n\n.usef-modal-eyebrow {\n\tfont-size: 0.6875rem;\n\tfont-weight: 700;\n\tletter-spacing: 0.12em;\n\ttext-transform: uppercase;\n\tcolor: var(--bs-secondary);\n\tline-height: 1;\n}\n\n.usef-modal-title {\n\tfont-size: 1.15rem;\n\tfont-weight: 700;\n\tletter-spacing: 0.01em;\n\tmargin: 0;\n\tline-height: 1.2;\n}\n\n/* Modal Body */\n.usef-modal-body {\n\tpadding: 1.25rem 1.5rem;\n\tbackground-color: var(--bs-body-bg);\n}\n\n/* Search Panels */\n.usef-search-panels {\n\tdisplay: flex;\n\tgap: 0;\n\tmargin-bottom: 1.5rem;\n\tborder: 1px solid var(--bs-border-color);\n\tborder-radius: 0.5rem;\n\toverflow: hidden;\n}\n\n.usef-panel {\n\tflex: 1;\n\tmin-width: 0;\n}\n\n.usef-panel-label {\n\tfont-size: 0.6875rem;\n\tfont-weight: 700;\n\tletter-spacing: 0.1em;\n\ttext-transform: uppercase;\n\tcolor: var(--bs-secondary);\n\tbackground-color: var(--bs-tertiary-bg, #f8f9fa);\n\tborder-bottom: 1px solid var(--bs-border-color);\n\tpadding: 0.5rem 1rem;\n}\n\n.usef-panel-body {\n\tpadding: 1rem;\n}\n\n.usef-panel-divider {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 2.5rem;\n\tflex-shrink: 0;\n\tbackground-color: var(--bs-tertiary-bg, #f8f9fa);\n\tborder-left: 1px solid var(--bs-border-color);\n\tborder-right: 1px solid var(--bs-border-color);\n\tposition: relative;\n}\n\n.usef-or-badge {\n\tfont-size: 0.6875rem;\n\tfont-weight: 600;\n\ttext-transform: uppercase;\n\tletter-spacing: 0.08em;\n\tcolor: var(--bs-secondary);\n\tbackground-color: var(--bs-body-bg);\n\tborder: 1px solid var(--bs-border-color);\n\tborder-radius: 50%;\n\twidth: 1.75rem;\n\theight: 1.75rem;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tline-height: 1;\n}\n\n/* Form Fields */\n.usef-field-label {\n\tfont-size: 0.6875rem;\n\tfont-weight: 600;\n\tletter-spacing: 0.06em;\n\ttext-transform: uppercase;\n\tcolor: var(--bs-secondary);\n\tmargin-bottom: 0.3rem;\n}\n\n.usef-input {\n\tfont-size: 0.9rem;\n}\n\n.usef-search-btn {\n\tfont-size: 0.8125rem;\n\tfont-weight: 600;\n\tletter-spacing: 0.04em;\n}\n\n/* Results Section */\n.usef-results-section {\n\tmargin-top: 0.5rem;\n}\n\n.usef-results-header {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 0.75rem;\n\tmargin-bottom: 0.75rem;\n\tpadding-bottom: 0.5rem;\n\tborder-bottom: 1px solid var(--bs-border-color);\n}\n\n.usef-results-count {\n\tfont-size: 0.6875rem;\n\tfont-weight: 700;\n\tletter-spacing: 0.1em;\n\ttext-transform: uppercase;\n\tcolor: var(--bs-secondary);\n}\n\n/* Result Cards */\n.usef-result-card {\n\tborder: 1px solid var(--bs-border-color);\n\tborder-radius: 0.5rem;\n\toverflow: hidden;\n\tmargin-bottom: 0.75rem;\n}\n\n.usef-result-card:last-child {\n\tmargin-bottom: 0;\n}\n\n.usef-result-header {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 1rem;\n\tpadding: 0.75rem 1rem;\n\tbackground-color: var(--bs-tertiary-bg, #f8f9fa);\n\tborder-bottom: 1px solid var(--bs-border-color);\n}\n\n.usef-result-name {\n\tfont-size: 1rem;\n\tfont-weight: 700;\n\tline-height: 1.2;\n\tflex: 1;\n\tmin-width: 0;\n}\n\n.usef-result-actions {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 0.875rem;\n\tflex-shrink: 0;\n}\n\n.usef-select-btn {\n\tfont-size: 0.75rem;\n\tfont-weight: 700;\n\tletter-spacing: 0.06em;\n\ttext-transform: uppercase;\n\tpadding: 0.3rem 0.875rem;\n\twhite-space: nowrap;\n}\n\n.usef-suspension-alert {\n\tborder-radius: 0;\n\tborder-left: none;\n\tborder-right: none;\n\tborder-top: none;\n\tmargin-bottom: 0 !important;\n\tpadding: 0.5rem 1rem;\n\tfont-size: 0.875rem;\n}\n\n.usef-result-body {\n\tpadding: 0.875rem 1rem;\n}\n\n/* Key-Value Pairs */\n.usef-kv {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 0.1rem;\n}\n\n.usef-kv--inline {\n\tflex-direction: row;\n\talign-items: center;\n\tgap: 0.4rem;\n}\n\n.usef-kv-label {\n\tfont-size: 0.625rem;\n\tfont-weight: 700;\n\tletter-spacing: 0.1em;\n\ttext-transform: uppercase;\n\tcolor: var(--bs-secondary);\n\tline-height: 1;\n}\n\n.usef-kv-value {\n\tfont-size: 0.875rem;\n\tfont-weight: 500;\n\tline-height: 1.2;\n\tcolor: var(--bs-body-color);\n}\n\n.usef-id-value {\n\tfont-size: 0.9rem;\n\tfont-weight: 700;\n\tfont-variant-numeric: tabular-nums;\n}\n\n/* Details Grid */\n.usef-details-grid {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tgap: 0.75rem 1.5rem;\n\tmargin-bottom: 0.75rem;\n}\n\n/* Sub-sections (Owners, Memberships, Measurements) */\n.usef-memberships {\n\tborder-top: 1px solid var(--bs-border-color);\n\tpadding-top: 0.75rem;\n\tmargin-top: 0.25rem;\n}\n\n.usef-subsection-label {\n\tfont-size: 0.625rem;\n\tfont-weight: 700;\n\tletter-spacing: 0.12em;\n\ttext-transform: uppercase;\n\tcolor: var(--bs-secondary);\n\tmargin-bottom: 0.5rem;\n}\n\n.usef-membership-row {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tgap: 0.625rem 1.25rem;\n\tpadding: 0.5rem 0;\n\tborder-bottom: 1px solid var(--bs-border-color-translucent, rgba(0,0,0,.08));\n}\n\n.usef-membership-row:last-child {\n\tborder-bottom: none;\n\tpadding-bottom: 0;\n}\n\n/* Empty State */\n.usef-empty-state {\n\ttext-align: center;\n\tpadding: 2.5rem 1rem;\n\tcolor: var(--bs-secondary);\n}\n\n.usef-empty-icon {\n\tfont-size: 2rem;\n\topacity: 0.4;\n\tmargin-bottom: 0.75rem;\n\tdisplay: block;\n}\n\n.usef-empty-text {\n\tfont-size: 0.875rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
